import React, { useEffect } from 'react';
import Popover from '@amzn/awsui-components-core/popover';
import ColumnLayout from '@amzn/awsui-components-core/column-layout';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import Box, { BoxProps } from '@amzn/awsui-components-core/box';
import Link from '@amzn/awsui-components-core/link';
import { logger } from 'src/logger';
import { UserActionsEventTypes } from 'src/components/das-finsuite/das-finsuite-constants';

interface AnnouncementBodyPopoverProps {
  title: string;
  link?: string;
  linkText?: string;
  popoverBody: string;
  boldTitle?: boolean;
}

const DFPPopover: React.FC<AnnouncementBodyPopoverProps> = ({ title, link, linkText, popoverBody, boldTitle = false }) => {
  return (
    <Popover
      fixedWidth
      size="large"
      dismissButton={false}
      content={
        <SpaceBetween size="m" direction="vertical">
          {link && linkText && (
            <Box variant="p" color="text-status-info" key="link">
              <Link
                href={link}
                external
                onFollow={() => {
                  logger.info(`DaS FinSuite -> User Action: Announcement Widget link clicked`, {
                    event_type: UserActionsEventTypes.ANNOUNCEMENT_WIDGET_LINK_CLICKED,
                    value: title,
                    sub_value: link
                  });
                }}
              >
                {linkText}
              </Link>
            </Box>
          )}
          <Box variant="p" color="text-body-secondary" key="text-body-secondary">
            {popoverBody}
          </Box>
        </SpaceBetween>
      }
    >
      {boldTitle ? (
        <Box fontWeight="bold" color="text-status-info">
          {title}
        </Box>
      ) : (
        title
      )}
    </Popover>
  );
};

export default DFPPopover;
